import { useEffect } from 'react';

import { openHotkeyLayersState } from '@/ui/utilities/hotkey/states/openHotkeyLayersState';
import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';
import { removeFirstHotkeyLayer } from '@/ui/utilities/hotkey/utils/removeFirstHotkeyLayer';
import { useSetAtomState } from '@/ui/utilities/state/jotai/hooks/useSetAtomState';

type HotkeyLayerEffectProps = {
  layer: Exclude<HotkeyLayer, 'page'>;
};

// Mount it inside the content of a layer that is only rendered while open
// (a dialog popup, a menu, the side panel): the layer is registered for as
// long as that content is on screen, including its closing animation.
export const HotkeyLayerEffect = ({ layer }: HotkeyLayerEffectProps) => {
  const setOpenHotkeyLayers = useSetAtomState(openHotkeyLayersState);

  useEffect(() => {
    setOpenHotkeyLayers((openHotkeyLayers) => [...openHotkeyLayers, layer]);

    return () => {
      setOpenHotkeyLayers((openHotkeyLayers) =>
        removeFirstHotkeyLayer(openHotkeyLayers, layer),
      );
    };
  }, [layer, setOpenHotkeyLayers]);

  return null;
};
